export default __webpack_public_path__ + "static/media/graphic-3.b75fbe61.png";